import { Component, OnInit } from '@angular/core';
import {Model} from '../../app.model';
import {CountryService} from '../../country/country.service';
import {CompanyService} from '../company.service';
import {AutorunComponent} from '@myshared/autorun.component';
import {Company} from "../company.model";
import {Country} from "../../country/country.model";
import {MessageService} from "primeng/api";
import {I18NextService} from "angular-i18next";
import {FormEmitter} from "../../forms/form.component";
import {Tenant} from '../../auth/account.model';
import { showElectronicInvoiceMailInputField } from '../company.utils';

@Component({
    selector: 'app-company-view',
    templateUrl: './company-details.component.html',
    styleUrls: [],
    standalone: false
})
export class CompanyDetailsComponent extends AutorunComponent implements OnInit {
  company: Company;
  countries: Country[];
  tenant: Tenant;

  constructor(private m: Model,
              private countryService: CountryService,
              private companyService: CompanyService,
              private messageService: MessageService,
              private i18next: I18NextService) {
    super();
  }

  ngOnInit() {
    this.autorun(() => {
      this.company = this.m.company.company;
      this.countries = this.m.country.countries;
      this.tenant = this.m.account.currentUser.tenant;
    });
    this.countryService.refresh();
    this.companyService.refresh();
  }

  get showElectronicInvoiceMailInputField(): boolean {
    return showElectronicInvoiceMailInputField(this.tenant);
  }

  onSubmit(form: FormEmitter<Company>) {
    const company = form.data;
    company.country = this.company.country;
    this.companyService.update(company).subscribe(r => {
      if (r) {
        this.messageService.add({
          severity: 'success',
          summary: this.i18next.t('company_update_success_summary') as string,
          detail: this.i18next.t('company_update_success_detail') as string
        });
      } else {
        this.messageService.add({
          severity: 'error',
          summary: this.i18next.t('company_update_error_summary') as string,
          detail: this.i18next.t('company_update_error_detail') as string
        });
      }
    });
  }
}
